import services from "@/shared/http";
import * as types from "./mutations-types";
import store from "@/store";
import { cleanDuplicateParams } from "@/shared/helpers/urls";

/* Esse função retorna o link completo do produto + parametros de trackeamento */
export const fetchSharedLink = async (_, payload) => {
  const isDashboardCentralized =
    store.getters["my_lists/isDashboardCentralized"];
  const getAllCompaniesInCentralized =
    store.getters["my_lists/getAllCompaniesInCentralized"];

  /**
   * No dash centralizado, busca o ID do influ na respectiva marca ( do produto a ser compartilhado  ),
   * para enviar no paylaod
   */
  if (isDashboardCentralized) {
    const { parent_id } = payload;

    if (!parent_id) return console.log("parent_id é obrigatório");

    const getCompany = getAllCompaniesInCentralized.find(
      (company) => company.id == parent_id
    );

    if (!getCompany || !getCompany?.partners) return;

    const partner_id = getCompany.partners[0].id;

    payload = {
      ...payload,
      partner_id,
    };
  }

  const response = await services.simplified_sharing_products.getSharedLink(
    {},
    payload
  );

  const { shared_link } = response;

  if (!shared_link) throw new Error("Houve um erro 'shared_link' não veio");

  return cleanDuplicateParams(shared_link);
};

export const addProductToList = ({ commit }, product) => {
  commit(types.ADD_PRODUCT_TO_LIST, product);
};

export const removeProductFromList = ({ commit }, product) => {
  commit(types.REMOVE_PRODUCT_FROM_LIST, product);
};

export const removeAllProductFromList = ({ commit }) => {
  commit(types.REMOVE_ALL_PRODUCTS_FROM_LIST);
};

export const updateCustomMessage = ({ commit }, message) => {
  commit(types.UPDATE_CUSTOM_MESSAGE, message);
};
